/* @flow */

import * as React from 'react'

import {
  ControlLabel,
  FormGroup,
  FormInput,
} from '../../../../../infrastructure/components/Formik'

import { SpacingSettings, DimensionsInput } from '../shared'

const WebshopContainerSettings = ({ values }) => {
  return (
    <div>
      <FormGroup>
        <ControlLabel>Max width</ControlLabel>
        <DimensionsInput
          modeName="data.max_width_mode"
          fixedName="data.fixed_max_width"
          parentPercentageName="data.parent_percentage_max_width"
          values={values}
        />
      </FormGroup>

      <SpacingSettings />
    </div>
  )
}

export default WebshopContainerSettings
